"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FatalRetryError = exports.ResponseError = void 0;
/**
 * A basic error wrapper that allows us to easily report specific input
 * errors returned by the server, given that they are reported inside the
 * `inputErrors` key.
 */
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(error, inputErrors) {
        if (inputErrors === void 0) { inputErrors = {}; }
        var _this = _super.call(this, error) || this;
        _this.error = error;
        _this.inputErrors = inputErrors;
        _this.name = 'Network Error';
        _this.message = 'Error';
        Object.setPrototypeOf(_this, ResponseError.prototype);
        return _this;
    }
    return ResponseError;
}(Error));
exports.ResponseError = ResponseError;
var FatalRetryError = /** @class */ (function (_super) {
    __extends(FatalRetryError, _super);
    function FatalRetryError(response) {
        var _this = _super.call(this, 'fatal') || this;
        _this.isFatalRetry = true;
        _this.response = response;
        /**
         * TypeScript 4 introduced new breaking changes to Error subclassing.
         * The new changes introduced the following unexpected behaviors:
         *  - methods may be undefined on objects returned by constructing the subclass.
         *  - instanceof will be broken between instances of subclass and their instances
         *       (i.e. new FatalErrorRetry() instanceof FatalErrorRetry will return false)
         *
         * For more info see: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
         *
         * To rectify this, the prototype needs to be manually adjusted:
         */
        Object.setPrototypeOf(_this, FatalRetryError.prototype);
        return _this;
    }
    return FatalRetryError;
}(Error));
exports.FatalRetryError = FatalRetryError;
//# sourceMappingURL=NetworkTypes.js.map